<div class="viewport">
	<!-- Empty div for switiching screens/games -->
</div>
